const PromiseToPayReportActionTypes = {
	/***************** GET PROMISE TO PAY REPORT START ************* */
	GET_PROMISE_TO_PAY_REPORT_LIST_START: 'get_promise_to_pay_report_list_start',
	GET_PROMISE_TO_PAY_REPORT_LIST_SUCCESS: 'get_promise_to_pay_report_list_success',
	GET_PROMISE_TO_PAY_REPORT_LIST_FAILURE: 'get_promise_to_pay_report_list_failure',
	GET_PROMISE_TO_PAY_REPORT_LIST_RESPONSE_RESET: 'get_promise_to_pay_report_list_response_reset',
	GET_PROMISE_TO_PAY_REPORT_LIST_RESPONSE_CHANGED:
		'get_promise_to_pay_report_list_response_changed',
	/***************** GET PROMISE TO PAY REPORT END ************* */

	/******* START FETCH GROUP LOAN OFFICER LIST ***********/
	FETCH_GROUP_LOAN_OFFICER_LIST_START: 'fetch_group_loan_officer_list_start',
	FETCH_GROUP_LOAN_OFFICER_LIST_SUCCESS: 'fetch_group_loan_officer_list_success',
	FETCH_GROUP_LOAN_OFFICER_LIST_FAILURE: 'fetch_group_loan_officer_list_failure',
	FETCH_GROUP_LOAN_OFFICER_LIST_RESPONSE_RESET: 'fetch_group_loan_officer_list_response_reset',
	FETCH_GROUP_LOAN_OFFICER_LIST_RESPONSE_CHANGED:
		'fetch_group_loan_officer_list_response_changed',
	/******* END FETCH GROUP LOAN OFFICER LIST  ***********/

	/** ***************** GET PROMISE TO PAY REPORT EXCEL START *********************** */
	GET_PROMISE_TO_PAY_EXCEL_START: 'get_promise_to_pay_report_excel_start',
	GET_PROMISE_TO_PAY_EXCEL_SUCCESS: 'get_promise_to_pay_report_excel_success',
	GET_PROMISE_TO_PAY_EXCEL_FAILURE: 'get_promise_to_pay_report_excel_failure',
	GET_PROMISE_TO_PAY_EXCEL_RESPONSE_RESET_START: 'get_promise_to_pay_report_excel_reset_start',
	GET_PROMISE_TO_PAY_EXCEL_RESPONSE_CHANGED: 'get_promise_to_pay_report_response_changed',
	/** ***************** GET PROMISE TO PAY REPORT EXCEL END *********************** */
};

export default PromiseToPayReportActionTypes;
